export default "__VITE_ASSET__BbPr0Dxu__"